import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbPaginatedResponse } from 'libs/gb-dashboard/core/data-access/src'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import {
  EventTicketPurchasePayload,
  EventTicketPurchasesEntity,
  RefundEventTicketPurchaseResult,
} from './event-ticket-purchases.models'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPurchasesApiService extends GbApiService {
  getEventTicketPurchases(
    urlName: string,
    offset: number,
    searchTerm?: string,
    ordering?: string,
    refunded?: boolean,
  ): Observable<GbPaginatedResponse<EventTicketPurchasesEntity>> {
    let params = new HttpParams().set('limit', this.appConfig.itemsPageSize).set('offset', offset)
    if (searchTerm) params = params.set('search', searchTerm)
    if (ordering) params = params.set('ordering', ordering)
    if (refunded === false) params = params.set('refunded', false)

    const url = `auctions/${urlName}/event-ticket-purchases/`

    return this.get<GbPaginatedResponse<EventTicketPurchasesEntity>>(url, { params })
  }

  syncEventTicketPurchase(urlName: string, purchaseUuid = ''): Observable<EventTicketPurchasesEntity> {
    return this.get<EventTicketPurchasesEntity>(`auctions/${urlName}/event-ticket-purchases/${purchaseUuid}/`)
  }

  createEventTicketPurchase(
    urlName: string,
    payload: EventTicketPurchasePayload,
  ): Observable<EventTicketPurchasesEntity> {
    return this.post<EventTicketPurchasesEntity>(
      `auctions/${urlName}/event-ticket-purchases/`,
      payload,
      this.skipPusherOptions,
    )
  }

  issueEventTicketPurchase(urlName: string, uuid: string): Observable<EventTicketPurchasesEntity> {
    return this.get<EventTicketPurchasesEntity>(`auctions/${urlName}/event-ticket-purchases/${uuid}/issue/`)
  }

  refundTicketPurchase(urlName: string, uuid: string, tickets?: string[]): Observable<RefundEventTicketPurchaseResult> {
    return this.post<RefundEventTicketPurchaseResult>(
      `auctions/${urlName}/event-ticket-purchases/${uuid}/refund/`,
      tickets?.length ? { tickets } : {},
    )
  }
}
